import React, { FunctionComponent } from 'react';
import {
  toCurrencyWithSign,
  TWO_DECIMAL_PLACES,
} from 'scenes/common/helpers/currency';

const GovernmentChargesRow: FunctionComponent<{
  title: string;
  value: string;
}> = ({ title, value }) => (
  <tr>
    <td>{title}</td>
    <td>{toCurrencyWithSign(value, TWO_DECIMAL_PLACES)}</td>
  </tr>
);

export default GovernmentChargesRow;
